import Vue from 'vue'

import Vuex from 'vuex'

import notify from '@/common/notify.js'

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        //这里放全局参数
        token: localStorage.getItem('token') || '',
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
        //是否为手机
        isMobile: localStorage.getItem('isMobile') === "true",
        langList: JSON.parse(localStorage.getItem('langList') || '{}'),
        defaultLang: localStorage.getItem('defaultLang') || '',
        kefu: localStorage.getItem('kefu'),
        shareUrl: localStorage.getItem('shareUrl'),
        config: JSON.parse(localStorage.getItem('config') || '{}'),
    },
    mutations: {
        setUserInfo(state, Value) {
            state.userInfo = Value
            localStorage.setItem('userInfo', JSON.stringify(Value))
        },
        setToken(state, Value) {
            state.token = Value
            localStorage.setItem('token', Value)
        },
        setIsMobileValue(state, Value) {
            localStorage.setItem('isMobile', Value)
            state.isMobile = Value
            notify.init()
        },
        setLangList(state, Value) {
            localStorage.setItem('langList', JSON.stringify(Value))
            state.langList = Value
        },
        setDefaultLang(state, Value) {
            localStorage.setItem('defaultLang', Value)
            state.defaultLang = Value
        },
        setKefu(state, Value) {
            localStorage.setItem('kefu', Value)
            state.kefu = Value
        },
        setShareUrl(state, Value) {
            localStorage.setItem('shareUrl', Value)
            state.shareUrl = Value
        },
        setConfig(state, Value) {
            localStorage.setItem('config', JSON.stringify(Value))
            state.config = Value
        },
    },
    getters: {
        //get方法
        getUserInfo: state => state.userInfo,
        getIsMobile: state => state.isMobile,
        getToken: state => state.token,
        getLangList: state => state.langList,
        getDefaultLang: state => state.defaultLang,
        getKefu: state => state.kefu,
        getShareUrl: state => state.shareUrl,
        getConfig: state => state.config,
    },
    actions: {
        //这个部分我暂时用不上
    },
    modules: {
        //这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里
    }
})